// App Information
export const APP_NAME = 'ZEN';

// Features
export const APP_FEATURES = [
  {
    icon: 'Brain',
    title: 'Your custom AI',
    description:
      'Advanced AI that understands your projects, maintains context, and helps you stay organized with minimal effort',
  },
  {
    icon: 'Users',
    title: 'Team Collaboration',
    description:
      "Work together seamlessly with your team in real-time, share projects, assign tasks, and keep everyone in sync with your project's progress",
  },
  {
    icon: 'Grid',
    title: 'Flexible Workspaces',
    description:
      'Seamlessly switch between AI discussions, note-taking, lists, task management, moodboards,' +
      ' and bookmarks - all in one unified space',
  },
  {
    icon: 'FileText',
    title: 'Smart Document Analysis',
    description:
      'Upload documents and receive intelligent summaries, key insights, and contextual understanding of your project materials',
  },
  {
    icon: 'Mic',
    title: 'Voice-Enabled Workflow',
    description:
      'Capture ideas, create tasks, or take notes hands-free with advanced voice recognition and processing',
  },
  {
    icon: 'Image',
    title: 'Visual Organization',
    description:
      'Create beautiful moodboards to collect and organize visual inspiration for your projects',
  },
];

// File Upload
export const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25MB
export const ALLOWED_FILE_TYPES = ['application/pdf'];

// Image Upload
export const MAX_IMAGE_SIZE = 10 * 1024 * 1024; // 10MB
// Note: 'image/jpeg' is the only valid JPEG MIME type per IANA standards
// Some browsers report 'image/jpg' for JPEG files, so we include both for compatibility
export const ALLOWED_IMAGE_TYPES = [
  'image/jpeg',
  'image/jpg', // Non-standard but sent by some browsers
  'image/png',
  'image/gif',
  'image/webp',
] as const;
export const ALLOWED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp'] as const;
